export const WHATSAPP_LINK = "https://wa.me/5541984493170";

export const NAV_LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Cases", href: "#cases" },
  { label: "Processo", href: "#processo" },
  { label: "FAQ", href: "#faq" },
];

export const TECH_MARQUEE = [
  "Automação",
  "Dashboards",
  "Sites Profissionais",
  "Fluxos Automatizados",
  "Sistemas sob Medida",
];

export const SERVICES = [
  {
    index: "01",
    title: "SaaS & Sistemas sob Medida",
    description:
      "Plataformas, ERPs, painéis e ferramentas internas construídas do zero para resolver exatamente o problema do seu negócio.",
    stack: ["Next.js", "TypeScript", "Python", "Supabase", "Docker"],
  },
  {
    index: "02",
    title: "Landing Pages de Alta Conversão",
    description:
      "Páginas que posicionam, geram lead e vendem. Design editorial, copy estratégico e performance técnica.",
    stack: ["Next.js", "Vercel"],
  },
  {
    index: "03",
    title: "Automação de Processos",
    description:
      "Conectamos seus sistemas em fluxos que rodam sozinhos: notificações, relatórios e integrações acontecem sem precisar de você.",
    stack: ["n8n", "Webhooks", "APIs"],
  },
];

export const CASES = [
  {
    id: "gugu-turismo",
    title: "ERP de Gestão Rodoviária",
    client: "Gugu Turismo",
    description:
      "Sistema web completo para múltiplas filiais: mapa visual de assentos, check-in por QR Code, rastreio de encomendas com assinatura digital e gestão financeira em tempo real.",
    result: "Acesso simultâneo por todas as filiais em tempo real",
    url: "erp.guguturismo.com.br",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_custom-systems-3/artifacts/n3qu7rri_onibus_gugu.webp",
    size: "large",
  },
  {
    id: "uptake",
    title: "Sistema CRM",
    client: "Uptake Contabilidade",
    description:
      "CRM com dashboard administrativo, pipeline de vendas, controle de documentos e gestão de cobranças.",
    result: "Do briefing ao deploy em 21 dias",
    url: null,
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85",
    size: "small",
  },
  {
    id: "lorena-barreto",
    title: "Landing Page",
    client: "Lorena Barreto · Advogada Canônica",
    description:
      "Página de apresentação profissional com foco em conversão para consultas de nulidade matrimonial.",
    result: null,
    url: "lorenabarretoadvogada.com",
    image:
      "https://images.unsplash.com/photo-1772475385529-92037713a057?crop=entropy&cs=srgb&fm=jpg&q=85",
    size: "small",
  },
  {
    id: "automacao-fluxos",
    title: "Automação de Fluxos",
    client: "Cliente em construção",
    description:
      "Automação de processos internos via webhooks e integrações de API.",
    result: null,
    status: "Em build",
    url: null,
    image:
      "https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?crop=entropy&cs=srgb&fm=jpg&q=85",
    size: "large",
  },
];

export const PROCESS = [
  {
    index: "01",
    title: "Diagnóstico",
    tag: "Gratuito",
    description:
      "A gente lê o negócio antes de abrir o editor. Entrevista, mapeamento, escopo documentado. Você valida antes de qualquer linha de código.",
  },
  {
    index: "02",
    title: "Construção em Sprints",
    tag: "7 dias/sprint",
    description:
      "Entregas semanais. Você testa e aprova cada fase. Nada aparece do nada no final.",
  },
  {
    index: "03",
    title: "Entrega & Operação",
    tag: "30 dias de suporte",
    description:
      "Deploy em produção, treinamento e suporte. A gente não some depois que entrega.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Entregaram nosso sistema em menos de um mês. Superou tudo que esperávamos.",
    name: "Victor Ribeiro",
    role: "CEO · Uptake Contabilidade",
  },
  {
    quote:
      "Sistema completo, entregue no prazo. Resolveu um problema que a gente carregava há anos com planilhas e informação espalhada.",
    name: "Rafael Mendonça",
    role: "Representante · Gugu Turismo",
  },
  {
    quote:
      "A landing page transformou completamente a forma como apresento meu trabalho. Minhas consultas e o curso aumentaram significativamente: os clientes já chegam convencidos antes mesmo de falar comigo.",
    name: "Lorena Barreto",
    role: "Advogada Canônica · Nulidade Matrimonial",
  },
];

export const FAQ = [
  {
    q: "Qual o prazo médio de entrega?",
    a: "Nosso prazo médio é 21 dias úteis do briefing à entrega em produção. O prazo exato é definido antes do início, com escopo documentado e aprovado.",
  },
  {
    q: "Vocês atendem qual tamanho de empresa?",
    a: "Desde profissionais autônomos até empresas com múltiplas filiais. O que importa é o problema a resolver, não o tamanho.",
  },
  {
    q: "Como funciona o acompanhamento do projeto?",
    a: "Sprints semanais com entrega parcial. Você testa, valida e aprova antes de ir para a próxima fase. Sem surpresa no final.",
  },
  {
    q: "Qual o investimento médio?",
    a: "Landing pages a partir de R$850. Sistemas e ERPs, orçamento sob consulta conforme escopo. Toda proposta é gratuita.",
  },
  {
    q: "Trabalham com tecnologia específica?",
    a: "Nossa stack principal é Next.js, TypeScript, Supabase, Python e n8n. Integramos com qualquer API ou sistema existente.",
  },
  {
    q: "Como funciona o suporte?",
    a: "Acompanhamos os primeiros 30 dias em produção. Manutenção contínua disponível via plano mensal.",
  },
];
